<template>
  <PfModal
    :show-close="false"
    class="com_modal--no-header"
    :is-slim="true"
    :locked-ids="[]"
    data-testid="two-factor-auth-disabled-modal"
  >
    <div
      class="recovery-message"
    >
      <h1>
        {{ $t('feature.components.modal_two_factor_auth_disabled.is_not_active') }}
      </h1>

      <PfButtonBar
        align="center"
        class="recovery-message__button-bar"
      >
        <PfButtonBarButton
          data-testid="reactivate-two-factor-auth"
          @click="onClickReactivate"
        >
          {{ $t('feature.components.modal_two_factor_auth_disabled.reactivate') }}
        </PfButtonBarButton>

        <PfButtonBarLink
          data-testid="keep-two-factor-auth-disabled"
          @click="onClickDisable"
        >
          {{ $t('feature.components.modal_two_factor_auth_disabled.continue_without') }}
        </PfButtonBarLink>
      </PfButtonBar>
    </div>
  </PfModal>
</template>

<script>
import PfButtonBar from '@/components/PfButtonBar.vue'
import PfButtonBarButton from '@/components/PfButtonBarButton.vue'
import PfButtonBarLink from '@/components/PfButtonBarLink.vue'
import PfModal from '@/components/PfModal.vue'

export default {
  name: 'ModalTwoFactorAuthDisabled',

  components: {
    PfButtonBarLink,
    PfButtonBarButton,
    PfButtonBar,
    PfModal,
  },

  methods: {
    onClickReactivate () {
      this.$store.commit('layout/SET_SHOW_TWO_FACTOR_AUTH_DISABLED_MODAL', false)

      this.$router.push({
        name: 'account',
        query: {
          'enable-2fa': 'true',
        },
      })
    },

    onClickDisable () {
      this.$store.commit('layout/SET_SHOW_TWO_FACTOR_AUTH_DISABLED_MODAL', false)
    },
  },
}
</script>
